/// Minutos de um dia civil.
export const DAY_MINUTES = 24 * 60;

/// Lê o que a pessoa digitou: `1430`, `14:30`, `14h30`, `14h` e `9` valem. Devolve `null` para campo
/// vazio e `undefined` para texto que não é horário.
export function parseTimeText(text: string): string | null | undefined {
  const typed = text.trim().toLowerCase().replace(/\s/gu, '');
  if (typed === '') return null;
  let hours: number;
  let minutes: number;
  const separated = /^(\d{1,2})[:h](\d{2})?h?$/u.exec(typed);
  if (separated) {
    hours = Number(separated[1]);
    minutes = separated[2] ? Number(separated[2]) : 0;
  } else if (/^\d{1,4}$/u.test(typed)) {
    hours = Number(typed.length <= 2 ? typed : typed.slice(0, -2));
    minutes = typed.length <= 2 ? 0 : Number(typed.slice(-2));
  } else return undefined;
  if (hours > 23 || minutes > 59) return undefined;
  return formatMinutes(hours * 60 + minutes);
}

export function toMinutes(time: string): number {
  const [hours = 0, minutes = 0] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export function formatMinutes(total: number): string {
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}
